export class Field {
    public fieldName: string;
    public fieldType: string;
    public fieldRequired: boolean;
    public max: number;
}
